import React, { useState, Fragment } from "react";
import PreviewBox from "../WhatsappComponents/PreviewBox";
import {
    decodeString,
    getWAComponents,
    parseJSON,
    constructTemplateMsgFromApp,
    getErrorMsg,
    replaceSymbols,
    replaceSymbolsToHtml
} from "../../Common/Appcommon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleExclamation} from "@fortawesome/free-solid-svg-icons";
import CratioTooltip from "../../Common/CratioTooltip";


const AnalyticsPreview = (props) => {

    const { formData, formIndex, source,msgContentType,temptype } = props;

    if(formData[formIndex] === undefined){
        return (<></>);
    }

    const formInfo = formData[formIndex];
    let components = formInfo['Components'];
    let jsonInfo = formInfo['Message_Info'];/*(source === 'inbox') ? formInfo['Message_Info'] : formInfo['Message Info']*/;
    let waComponents = [];
    let replacedContent = {};
    let contentType = '';
    let type = formInfo['Type'] !== undefined ? formInfo['Type'] : 'out';
    let awsUrl = process.env.REACT_APP_CRATIO_AWS_S3_URL;
    const failedStatuses = ['failed', 'Failed', 'undeliverable','Undeliverable'];
    let isFailed = failedStatuses.includes(formInfo['Status']);
    let reason = getErrorMsg(formInfo['Reason']);
    let isReplied = formInfo['Is_Replied'];

    const constructMsgFromUser = (components,replacedContent) => {
        let repliedMessage = {};

        try{

            let bussinessData = {};

            if(jsonInfo['entry'][0]['changes'][0]['value']['messaging_product'] !== undefined){
                bussinessData = jsonInfo['entry'][0]['changes'][0]['value'];
            }else {
                bussinessData = jsonInfo['entry'][0]['changes'][0]['value']['whatsapp_business_api_data'];
            }
            repliedMessage = bussinessData['messages'][0];
        }catch (e) {}

        if(Object.keys(repliedMessage).length > 0) {
            contentType = repliedMessage['type'];
            let bodyText = "";
            if (contentType === 'text' || contentType === 'reaction') {
                if(contentType === 'text'){
                    bodyText = repliedMessage[contentType]["body"] !== undefined ? repliedMessage[contentType]['body'] : "";
                }else{
                    bodyText = repliedMessage[contentType]["emoji"] !== undefined ? repliedMessage[contentType]['emoji'] : "";
                }
                components.push({
                    "type": "BODY",
                    "text": bodyText
                })
            //Handle button components
            }else if(contentType === 'button'){
                let button = [
                    {
                        type : repliedMessage[contentType]["type"] !== undefined ? repliedMessage[contentType]['type'] : "button",
                        text : repliedMessage[contentType]["text"] !== undefined ? repliedMessage[contentType]['text'] : "button"
                    }
                ];

                components.push({
                    "type": "BODY",
                    "text": repliedMessage[contentType]["text"]
                })
            }else if(contentType === 'interactive'){
                if(repliedMessage[contentType]['type'] === "nfm_reply"){
                    let nfm_reply = repliedMessage[contentType]["nfm_reply"];
                    let response_json = nfm_reply["response_json"];
                    if(response_json && response_json !== null && response_json !== ""){
                        response_json = parseJSON(response_json);
                        Object.entries(response_json).map(([key, value]) => {
                            if(key !== "flow_token" && key !== "wa_flow_response_params"){
                                key = replaceSymbols('_',[" "," "],key);
                                bodyText = bodyText + key + " : *" + value + "*\n";
                            }
                        });
                    }
                }else{
                    let interactiveType = repliedMessage[contentType] !== undefined && repliedMessage[contentType]["type"] !== undefined ? repliedMessage[contentType]["type"] : "";
                    bodyText = repliedMessage[contentType] !== undefined && repliedMessage[contentType][interactiveType] !== undefined && repliedMessage[contentType][interactiveType]['title'] !== undefined ? repliedMessage[contentType][interactiveType]['title'] : "interactive"
                }
                components.push({
                    "type": "BODY",
                    "text": bodyText
                })
            } else {

                //Get media link based on their type.
                if (contentType === 'document') {
                    bodyText = (repliedMessage[contentType]["filename"] !== undefined) ? repliedMessage[contentType]["filename"] : "";
                } else if (contentType === 'video' || contentType === 'image' || contentType === 'audio') {
                    bodyText = repliedMessage[contentType]["caption"] !== undefined ? repliedMessage[contentType]["caption"] : "";
                } else if (contentType === 'location') {
                    bodyText = repliedMessage[contentType]["name"] !== undefined ? repliedMessage[contentType]["name"] : "";
                    replacedContent['mediaUrl'] = (repliedMessage[contentType] !== undefined) ? repliedMessage[contentType] : {};
                } else {
                    bodyText = contentType;
                }

                let mediaField = 'Media_URL'; /*source === 'inbox' ? 'Media_URL' : 'Media URL'*/
                if (formInfo[mediaField] !== undefined && formInfo[mediaField] != null && formInfo[mediaField] !== "") {

                    replacedContent['mediaUrl'] = formInfo[mediaField].startsWith("http") ? formInfo[mediaField] : `${awsUrl}${formInfo[mediaField]}`;
                }

                components.push(
                    {
                        "type": "HEADER",
                        "format": contentType.toUpperCase()
                    },
                    {
                        "type": "BODY",
                        "text": bodyText
                    }
                )
            }
        }

        return [ components, replacedContent ];
    }

    const constructMsgFromApp = (components, replacedContent) => {

            let contentType = jsonInfo['type'];
            let bodyText = "";
            if (contentType === 'text') {
                bodyText = jsonInfo[contentType]['body'];
                components.push({
                    "type": "BODY",
                    "text": bodyText
                })
            // Handle interactive messages
            } else if(contentType === 'interactive'){

                bodyText = jsonInfo[contentType]['body'] !== undefined && jsonInfo[contentType]['body']['text'] !== undefined
                    ? jsonInfo[contentType]['body']['text'] : "";

                let replyButtons = [];

                // Handle list interactive messages
                if(jsonInfo[contentType]['type'] === "list"){

                    let listText = (jsonInfo[contentType]['action'] !== undefined && jsonInfo[contentType]['action']['button'] !== undefined) ?
                        jsonInfo[contentType]['action']['button'] : "";

                    replyButtons = [{
                        "type": "list",
                        "text":  listText,
                    }]
                // Handle button interactive messages
                } else if(jsonInfo[contentType]['type'] === "button"){
                    if(jsonInfo[contentType]['action'] !== undefined && jsonInfo[contentType]['action']['buttons'] !== undefined){

                        let intractiveBtnList = jsonInfo[contentType]['action']['buttons'];

                        for(let btnkey in intractiveBtnList){
                            replyButtons.push({"type": intractiveBtnList[btnkey].type, "text":  intractiveBtnList[btnkey][intractiveBtnList[btnkey].type].title })
                        }
                    }
                }

                //interactive message header info
                if(jsonInfo[contentType]['header'] !== undefined){
                    const header = jsonInfo[contentType]['header'];
                    const headerType = header['type'];

                    replacedContent['mediaUrl'] = (header[headerType]['link'] !== undefined) ? header[headerType]['link'] : {};

                    components.push({
                        "type": "HEADER",
                        "format": headerType.toUpperCase()
                    })
                }

                if(bodyText !== ""){
                    components.push({
                        "type": "BODY",
                        "text": bodyText
                    })
                }

                if(replyButtons.length > 0){
                    components.push({
                        "type": "BUTTONS",
                        "buttons" : replyButtons
                    })
                }

            }else {

                replacedContent['mediaUrl'] = jsonInfo[contentType]["link"];

                //Get media link based on their type.
                /*if (contentType === 'document') {
                    bodyText = (jsonInfo[contentType]["filename"] !== undefined) ? jsonInfo[contentType]["filename"] : "";
                } else */
                if (contentType === 'video' || contentType === 'image' || contentType === 'audio' || contentType === 'document') {
                    bodyText = jsonInfo[contentType]["caption"] !== undefined ? jsonInfo[contentType]["caption"] : "";
                } else if (contentType === 'location') {
                    bodyText = jsonInfo[contentType]["name"] !== undefined ? jsonInfo[contentType]["name"] : "";
                    replacedContent['mediaUrl'] = (jsonInfo[contentType] !== undefined) ? jsonInfo[contentType] : {};
                }

                components.push(
                    {
                        "type": "HEADER",
                        "format": contentType.toUpperCase()
                    },
                    {
                        "type": "BODY",
                        "text": bodyText
                    }
                )
            }

        return [ components, replacedContent ];
    }
    
    let isInboundFailed = false;
    let isListView = (props.isListView !== undefined);

    //To handle messages sent to customers from app
    if(type !== undefined && type !== null && type.toLowerCase() === 'out'){
        try{
            if(components !== undefined && components !== '' && components != null){
                components = parseJSON(decodeString(components));
                waComponents = getWAComponents(components);
            }
        }catch(e){
            console.log("Error : ",e);
            console.log("Error Type of Message : ",type);
        }

        if(jsonInfo !== undefined){
            jsonInfo = parseJSON(decodeString(jsonInfo));

            if(jsonInfo['type'] !== undefined){
                let msgType = jsonInfo['type'];
                if(msgType === 'template' || (msgType === 'interactive' && jsonInfo['interactive']['type'] === "flow")){
                    replacedContent = constructTemplateMsgFromApp(replacedContent,jsonInfo);
                }else{
                    components = [];
                    let result = constructMsgFromApp(components,replacedContent);
                    components = result[0];
                    replacedContent = result[1];
                    waComponents = getWAComponents(components);
                }
            }
        }
        //To handle messages received from the customers.
    }else{
        components = [];
        if(jsonInfo !== undefined){
            jsonInfo = parseJSON(decodeString(jsonInfo));
            console.log(jsonInfo);
            const status = jsonInfo?.entry?.[0]?.changes?.[0]?.value?.statuses?.[0]?.status;
            if (status === "failed") {
                isInboundFailed = true;
            }            
            let result = constructMsgFromUser(components,replacedContent);
            components = result[0];
            replacedContent = result[1];
            waComponents = getWAComponents(components);
        }
    }
    
    return (
        <Fragment>
            <div className={'analytics-msg-preview d-flex-alone align-center'}>
                <div className={'preview-content contentwordbreak'}>
                    {
                        components &&
                        <PreviewBox components={components} msgContentType={msgContentType} waComponents={waComponents} formData={replacedContent} source={source} temptype={temptype} formInfo={formInfo} is_Replied={isReplied}/>
                    }

                </div>

                        {/* <div className={'content-portion'}>
                            <div className="text-body" dir="auto">
                                <span className={'content-preview text-danger fw-bold'} dir="auto">{"Message loading Failed"}</span>
                            </div>
                        </div> */}
                {
                    isInboundFailed && (
                        <span className="del-msg">
                            <FontAwesomeIcon icon={faCircleExclamation}/> {replaceSymbolsToHtml("&nbsp; _ *Message loading failed * &nbsp; &nbsp; \n\n _", true)} 
                        </span>	
                    )
                }
                {
                    isFailed && isListView &&
                    <>
                        <CratioTooltip 
                            title={reason} 
                            content={
                                <span 
                                    id={ `` } 
                                    className={`chat__failed_icon mr-1`}>
                                        <FontAwesomeIcon icon={faCircleExclamation}/>
                                </span>
                            }
                        />

                    </>
                }
            </div>

        </Fragment>
    )
}


export default AnalyticsPreview;
